// extracted by mini-css-extract-plugin
export var background = "bP_fJ";
export var body = "bP_fb";
export var button = "bP_bC";
export var card = "bP_fG";
export var content = "bP_L";
export var footer = "bP_fK";
export var header = "bP_fH";
export var subtitle = "bP_fg";
export var title = "bP_V";